import { useGetUser } from 'src/shared/queries/useGetUser';
import { DateFormat, getFormattedDate } from '../formatters/formatDate';

export const useFormatDate = (date?: string): string => {
  const { data: userInfo } = useGetUser();

  if (!date) return '';

  const userPreferredFormat = userInfo?.userSettings?.dateFormat as DateFormat;

  return getFormattedDate(date, userPreferredFormat);
};
